export function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}
